import { OrganizationSurveyDto } from "../../server/dto/org/OrganizationSurveyDto";
import { LocalSurveyAnswerPendingUpdate } from "../../server/dto/org/OrganizationSurveyLocal";
import { PatchOrganizationSurveyAnswerRequest } from "../../server/dto/org/OrganizationSurveyRequestDto";

export const addPendingAnswers = (
  updates: PatchOrganizationSurveyAnswerRequest[],
  surveyDto: OrganizationSurveyDto,
) => {
  removePendingAnswers(updates, surveyDto);

  const newPending = surveyDto?._local?.answers || [];
  newPending.push(
    ...updates.map((u) => ({
      slug: u.slug,
      answer: u.answer,
      flaggedForReview: u.flaggedForReview,
    })),
  );

  surveyDto._local = surveyDto._local ?? {};
  surveyDto._local.answers = newPending;
};

export const removePendingAnswers = (
  updates: PatchOrganizationSurveyAnswerRequest[],
  surveyDto: OrganizationSurveyDto,
) => {
  const newPending = surveyDto?._local?.answers || [];
  updates.forEach((update) => {
    const idx = newPending.findIndex((p) => p.slug == update.slug);
    if (idx >= 0) {
      newPending.splice(idx, 1);
    }
  });

  surveyDto._local = surveyDto._local ?? {};
  surveyDto._local.answers = newPending;
};

export const applyPendingAnswers = (
  pending: LocalSurveyAnswerPendingUpdate[],
  surveyDto: OrganizationSurveyDto,
) => {
  pending.forEach((p) => {
    const value = surveyDto.answers[p.slug] ?? { slug: p.slug };
    value.answer = p.answer;
    value.flaggedForReview = p.flaggedForReview;
    surveyDto.answers[p.slug] = value;
  });
};
